var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAdvanced11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4F8FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_191)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M337.272 36.1625C397.155 33.1046 416.271 74.4336 510.737 57.2622C586.064 43.5721 618.492 94.6865 627.873 126.442C632.35 141.614 633.487 200.914 592.152 201.761C451.873 204.678 339.475 358.374 271.847 223.966C244.417 169.441 201.329 43.1251 337.272 36.1625Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-169.728 244.162C-109.845 241.105 -90.7292 282.434 3.73716 265.262C79.0639 251.572 111.492 302.686 120.873 334.442C125.35 349.614 126.487 408.914 85.1516 409.761C-55.1267 412.678 -167.525 566.374 -235.153 431.966C-262.583 377.441 -305.671 251.125 -169.728 244.162Z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAdvanced11);
export default __webpack_public_path__ + "static/media/bg-advanced11.918054dc1e3df60ecc112e1941ce7550.svg";
export { ForwardRef as ReactComponent };